import styles from "./header.module.css";

import SearchClients from "../search-clients";
import { inject, observer } from "mobx-react";
import { ClientOverviewStore, EmptyClientData } from "../../store/store";
import { useTranslation } from "react-i18next";
import { TabItem, TabPanel } from "../../../../components/tab-panel";
import { Button } from "@mui/material";
import classNames from "classnames";
import UserSettingsStore, {
    UserSettings,
} from "../../../../store/user-settings";

export interface HeaderProps {
    clientOverviewStore?: ClientOverviewStore;
    userSettingsStore?: UserSettingsStore;
}

function Header(props: HeaderProps) {
    const { t } = useTranslation("client-grid");
    const { clientOverviewStore, userSettingsStore } = props;
    const privacyMode = userSettingsStore?.getUserSetting(
        UserSettings.PRIVACY_MODE
    );

    const render = () => {
        return (
            <div className={styles["clients-overview-header"]}>
                <div className={styles["clients-overview-tabs"]}>
                    <TabPanel
                        activeKey={clientOverviewStore!.selectedTab}
                        onItemChange={(key: string) => {
                            clientOverviewStore!.setSelectedTab(key);
                        }}
                    >
                        <TabItem
                            itemKey={"client-status"}
                            label={t("ClientStatus")}
                        />
                        <TabItem
                            itemKey={"alarm-settings"}
                            label={t("AlarmOverview")}
                        />
                    </TabPanel>
                </div>

                <div className={styles["clients-overview-filter-inputs"]}>
                    <div
                        className={classNames(styles["privacy-mode-button"], {
                            [styles["enabled"]]: privacyMode,
                        })}
                    >
                        <Button
                            style={{
                                textTransform: "none",
                                whiteSpace: "nowrap",
                            }}
                            variant="contained"
                            onClick={() => {
                                userSettingsStore?.setUserSetting(
                                    UserSettings.PRIVACY_MODE,
                                    !privacyMode
                                );

                                clientOverviewStore!.setSelectedClient(
                                    EmptyClientData
                                );
                                clientOverviewStore!.setSearchValue("");
                            }}
                        >
                            {t("PrivacyMode")}
                        </Button>
                    </div>
                    <div className={styles["clients-overview-search"]}>
                        <SearchClients onSearchChange={onSearchChange} />
                    </div>
                </div>
            </div>
        );
    };

    const onSearchChange = () => {
        const { clientOverviewStore } = props;

        clientOverviewStore!.executeOnReload = () => {
            selectClientOnPage();
            clientOverviewStore!.executeOnReload = () => {};
        };

        setTimeout(() => {
            selectClientOnPage();
        });
    };

    const selectClientOnPage = () => {
        const selectedClientElement =
            document.querySelector("#selected-client");
        if (selectedClientElement) {
            selectedClientElement.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "start",
            });
        }
    };

    return render();
}

export default inject(
    "clientOverviewStore",
    "userSettingsStore"
)(observer(Header));
